// Components with document-level registries must release their old controls before replacement.
// This bridge is stateless: each bundle uses the owning page's existing lifecycle helpers.
export function replaceHydratedHtml(root: HTMLElement, html: string): void {
    const page = window as Window & {
        destroyTomSelectIn?: (root: Element) => void;
        disposeBootstrapTooltipsWithin?: (root: Element) => void;
    };
    page.destroyTomSelectIn?.(root);
    page.disposeBootstrapTooltipsWithin?.(root);
    root.innerHTML = html;
}
